const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/notifications.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { TbX } from "react-icons/tb";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
export const Route = createFileRoute("/_app/notifications")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface CreateNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: AdminNotificationFormData) => void;
  isLoading: boolean;
}
interface NotificationDetailModalProps {
  notification: any;
  isOpen: boolean;
  onClose: () => void;
}